import classes from "./styles.module.scss";
import { Component } from "react";
import React from "react";
import { MainStore } from "../../stores/MainStore";
import { observer } from "mobx-react";
import VideoAnimator from "./VideoAnimator";
import PageTransitionAnimator from "./PageTransitionAnimator";

interface IProps {
  store: MainStore;
}
interface IState {
  videoOut: boolean;
}
@observer
class Animator extends Component<IProps, IState> {
  state = {
    videoOut: false
  };
  render() {
    const { store } = this.props;
    if (!store) return null;
    const { videoOpening, onPageTransition } = store;
    return (
      <div className={classes.Animator}>
        {videoOpening && <VideoAnimator store={store} />}
        {onPageTransition && <PageTransitionAnimator />}
      </div>
    );
  }
}
export default Animator;
